import React from 'react';
import Header from '../homeComponents/header';
import { connect } from 'react-redux';
import { setRegistrationData } from '../../store/actions/action';


const ProfilePicker = ({ userTokenDetails, registrationData, showCreateProfileAdminModal, setRegistrationData, dispatch }) => {

  // console.log("type in picker:", userTokenDetails, registrationData);
  // console.log("userTokenDetails type in userTokenDetails:", userTokenDetails);
  const aclMap = userTokenDetails && userTokenDetails.aclMap ? userTokenDetails.aclMap : {}
  const userTypeId = userTokenDetails && userTokenDetails.type_id ? userTokenDetails.type_id : null
  const parentId = userTokenDetails ? userTokenDetails.parentId : 0
  //---------------------------------------------------------------------------------------------------------------------

  //---------------------------------------------------------------------------------------------------------------------
  //---- profile tiles[start]----
  var profileTiles = function () {
    return (
      <ul className="on-bording-dashboard">

        {registrationData.type == 1 && (showCreateProfileAdminModal.modal === false ||
          ((aclMap.mng_subusers_profile && aclMap.mng_subusers_profile.add_user_profile && aclMap.mng_subusers_profile.add_user_profile.isExist) &&
            (userTypeId === 14 || userTypeId === 1) &&
            showCreateProfileAdminModal.modal)) &&
          <>
            <li onClick={() => { setRegistrationData(14, 2, { techType: 1 }) }}>
              <div className="img-icon">
                <img src="../assets/images/onbording/usertype/14.png" alt="" />
                <h2> Trader/Importer/Exporter </h2>
              </div>
            </li>
            <li onClick={() => { setRegistrationData(6, 8, { techType: 1 }) }}>
              <div className="img-icon">
                <img src="../assets/images/onbording/usertype/6.png" alt="" />
                <h2> Investigation Agency </h2>
              </div>
            </li>
            <li onClick={() => { setRegistrationData(13, 8, { techType: 1 }) }}>
              <div className="img-icon">
                <img src="../assets/images/onbording/usertype/13.png" alt="" />
                <h2> Insurance Agency </h2>
              </div>
            </li>
          </>}

        {registrationData.type == 2 && (showCreateProfileAdminModal.modal === false ||
          ((aclMap.mng_subusers_profile && aclMap.mng_subusers_profile.add_user_profile && aclMap.mng_subusers_profile.add_user_profile.isExist) &&
            (userTypeId === 14 || userTypeId === 1) &&
            showCreateProfileAdminModal.modal)) &&
          <>
            <li onClick={() => { setRegistrationData(8, 2, { techType: 2 }) }}>
              <div className="img-icon">
                <img src="../assets/images/onbording/usertype/8.png" alt="" />
                <h2> For Bank / Financial Institutions</h2>
              </div>
            </li>
            <li onClick={() => { setRegistrationData(19, 8, { techType: 2 }) }}>
              <div className="img-icon">
                <img src="../assets/images/onbording/usertype/19.png" alt="" />
                <h2> For Traders (Trade Finance) </h2>
              </div>
            </li>
            {/* <li onClick={() => { setRegistrationData(20, 8, { techType: 4 }) }}>
              <div className="img-icon">
                <img src="../assets/images/onbording/usertechtype/channel-partners.png" alt="" />
                <h2> Channel Partner </h2>
              </div>
            </li> */}
          </>}

        {registrationData.type == 3 && (showCreateProfileAdminModal.modal === false ||
          ((aclMap.mng_subusers_profile && aclMap.mng_subusers_profile.add_user_profile && aclMap.mng_subusers_profile.add_user_profile.isExist) &&
            (userTypeId === 14 || userTypeId === 1) &&
            showCreateProfileAdminModal.modal)) &&
          <>
            <li onClick={() => { setRegistrationData(5, 8, { techType: 3 }) }}>
              <div className="img-icon">
                <img src="../assets/images/onbording/usertype/5.png" alt="" />
                <h2> Shipper </h2>
              </div>
            </li>
            <li onClick={() => { setRegistrationData(17, 8, { techType: 3 }) }}>
              <div className="img-icon">
                <img src="../assets/images/onbording/usertype/17.png" alt="" />
                <h2> Captain </h2>
              </div>
            </li>
            <li onClick={() => { setRegistrationData(11, 8, { techType: 3 }) }}>
              <div className="img-icon">
                <img src="../assets/images/onbording/usertype/11.png" alt="" />
                <h2> Stevedore </h2>
              </div>
            </li>
            <li onClick={() => { setRegistrationData(10, 8, { techType: 3 }) }}>
              <div className="img-icon">
                <img src="../assets/images/onbording/usertype/10.png" alt="" />
                <h2> Broker </h2>
              </div>
            </li>
            <li onClick={() => { setRegistrationData(7, 8, { techType: 3 }) }}>
              <div className="img-icon">
                <img src="../assets/images/onbording/usertype/7.png" alt="" />
                <h2> Vessel Master </h2>
              </div>
            </li>
            <li onClick={() => { setRegistrationData(18, 8, { techType: 3 }) }}>
              <div className="img-icon">
                <img src="../assets/images/onbording/usertype/18.png" alt="" />
                <h2> Carrier Agent </h2>
              </div>
            </li>
          </>}

        {((aclMap.mng_subusers_profile && aclMap.mng_subusers_profile.add_user_profile && aclMap.mng_subusers_profile.add_user_profile.isExist) &&
          (userTypeId === 14 || userTypeId === 1 || userTypeId === 19 || userTypeId === 8) &&
          showCreateProfileAdminModal.modal) &&
          <li onClick={() => { setRegistrationData(9, 2, { techType: registrationData.payload.techType || userTokenDetails?.tech_type_id }) }}>
            <div className="img-icon">
              <img src="../assets/images/onbording/usertype/9.png" alt="" />
              <h2> Employee </h2>
            </div>
          </li>
        }

        {((aclMap.mng_subusers_profile && aclMap.mng_subusers_profile.add_user_profile && aclMap.mng_subusers_profile.add_user_profile.isExist) &&
          ((userTypeId === 8 && parentId === 0)) &&
          showCreateProfileAdminModal.modal) &&
          <li onClick={() => { setRegistrationData(8, 2, {}) }}>
            <div className="img-icon">
              <img src="../assets/images/onbording/usertype/8.png" alt="" />
              <h2> Bank </h2>
            </div>
          </li>
        }

        {((aclMap.mng_subusers_profile && aclMap.mng_subusers_profile.add_user_profile && aclMap.mng_subusers_profile.add_user_profile.isExist) &&
          (userTypeId === 5 || userTypeId === 10 || userTypeId === 11 || userTypeId === 1) &&
          (showCreateProfileAdminModal.modal)) &&
          <>
            <li onClick={() => { setRegistrationData(7, 2, {}) }}>
              <div className="img-icon">
                <img src="../assets/images/onbording/usertype/7.png" alt="" />
                <h2> Vessel Master </h2>
              </div>
            </li>
            <li onClick={() => { setRegistrationData(18, 2, {}) }}>
              <div className="img-icon">
                <img src="../assets/images/onbording/usertype/18.png" alt="" />
                <h2> Carrier Agent </h2>
              </div>
            </li>
          </>
        }

      </ul >
    )
  }
  //---- profile tiles[end]----
  //---------------------------------------------------------------------------------------------------------------------


  //---------------------------------------------------------------------------------------------------------------------
  //--------final return[start]--------
  if ((aclMap.mng_subusers_profile && aclMap.mng_subusers_profile.add_user_profile && aclMap.mng_subusers_profile.add_user_profile.isExist) && showCreateProfileAdminModal.modal) {
    return (
      <div className="modal-body calc-inner-modal">
        <div className="custom-tab-content active-tab">
          {profileTiles()}
        </div>
      </div>
    )
  } else {
    return (
      <div className="on-bording">
        <div className="container-fluid">
          <div className="row">
            <Header title={'Who would you like to register as ?'} />
            <div className="outer-box mx-auto">
              {profileTiles()}
            </div>
          </div>
        </div>
      </div>
    )
  }
  //--------final return[end]--------
}
//---------------------------------------------------------------------------------------------------------------------


const mapStateToProps = state => {
  return {
    registrationData: state.registrationData,
    showCreateProfileAdminModal: state.showCreateProfileAdminModal
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setRegistrationData: (type, step, payload) => { dispatch(setRegistrationData({ type, step, payload })) }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfilePicker)
